import type { BlockChange } from "../protocol/protocol";

/** How a transaction's type or revenue flag changes, as the reclassify card's tables show it. */

export const NONE = "—";

/** The AI Analysis tab's names for a transaction's type and whether it counts as revenue. */
export const CATEGORY_NAMES: Record<string, string> = {
  MCA_DEPOSIT: "MCA_FUNDING",
  MCA_WITHDRAWAL: "MCA_PAYMENT",
  COLLECTION_PAYMENT: "COLLECTION",
  AUTO_LOAN_PAYMENT: "AUTO_LOAN",
  EQUIPMENT_PAYMENT: "EQUIPMENT",
  CREDIT_CARD_PAYMENT: "CARD_PAYMENT",
  SBA_LOAN_PAYMENT: "SBA_LOAN",
  TAX_PAYMENT: "TAX",
  RENT_LEASE: "RENT",
  OWNER_INJECTION: "OWNER_IN",
};
export const REVENUE_NAMES: Record<string, string> = { TR: "Revenue", NTR: "Not revenue" };
/** The funding decision's statuses ("review" from runs before needs_review). */
export const DECISION_NAMES: Record<string, string> = {
  approved: "Approved",
  declined: "Declined",
  needs_review: "Needs review",
  review: "Needs review",
};

export const moves = (change: BlockChange) => change.old !== change.new;

/** "old → new" with the old struck, or the value alone, muted, when it stays. */
export function Change({ change, names }: { change: BlockChange; names: Record<string, string> }) {
  const name = (value: string) => (value ? (names[value] ?? value) : NONE);
  if (!moves(change)) return <span className="text-muted-foreground">{name(change.new)}</span>;
  return (
    <span className="inline-flex flex-wrap items-baseline gap-x-1">
      <s className="text-muted-foreground">{name(change.old)}</s>
      <span aria-hidden className="text-muted-foreground">
        →
      </span>
      <span className="font-semibold text-primary">{name(change.new)}</span>
    </span>
  );
}
